import { useMemo } from "react";

import { Link, Route, Routes, useLocation } from "react-router-dom";

import { Menu } from "semantic-ui-react";

import { OpenAPI } from "simplydo/interfaces";

import { useAppSelector } from "store";
import util from "utils/utils";

import CalendarSettings from "components/calendars/CalendarManagement/EditCalendar/CalendarSettings";

import Planner from "./Planner";

type PlannerMenuProps = { challenge: OpenAPI.Schemas["Challenge"] };

const PlannerMenu = ({ challenge }: PlannerMenuProps) => {
  const challengeId = challenge?._id;
  const calendarId = challenge?.calendar?._id;
  const user = useAppSelector((state) => state.user);
  const location = useLocation();

  const canManageChallenge = useMemo(
    () => util.canManageChallenge(user, challenge),
    [user, challenge],
  );
  const canEditPlanner = useMemo(
    () =>
      canManageChallenge ||
      (calendarId &&
        util.hasPermission(user, "calendar.edit", calendarId, challengeId)),
    [user, canManageChallenge, calendarId, challengeId],
  );

  return (
    <div>
      <Menu pointing secondary>
        <Menu.Item
          active={util.activePath("/planner$", location)}
          icon="calendar"
          content="Planner"
          as={Link}
          to="."
        />
        {canEditPlanner ?
          <Menu.Item
            active={util.activePath("/planner/settings", location)}
            icon="cogs"
            content="Settings"
            as={Link}
            to="settings"
          />
        : null}
      </Menu>

      <Routes>
        {canEditPlanner ?
          <Route
            path="settings"
            element={
              <CalendarSettings
                forType="challenge"
                forId={challengeId}
                calendarId={calendarId}
              />
            }
          />
        : null}
        <Route path="/" element={<Planner challenge={challenge} />} />
      </Routes>
    </div>
  );
};

export default PlannerMenu;
